import { lightPalette } from '@app/theme';

import type { SxProps, Theme } from '@mui/material';


export type ScoreLevel = 'success' | 'warning' | 'error';

export const getScoreLevel = (score: number, maxScore: number): ScoreLevel => {
  const normalized = maxScore > 0 ? (score / maxScore) * 10 : 0;
  if (normalized >= 7) return 'success';
  if (normalized >= 5) return 'warning';
  return 'error';
};

export const tableHeaderCellSx: SxProps<Theme> = {
  fontSize: 10,
  fontWeight: 600,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  color: lightPalette.text.secondary,
  backgroundColor: lightPalette.border.light,
  borderBottom: `1px solid ${lightPalette.border.default}`,
  py: 1.5,
  px: 2,
};

export const zebraRowSx: SxProps<Theme> = {
  '&:last-child td': { borderBottom: 'none' },
  '&:nth-of-type(even) td': { backgroundColor: `${lightPalette.background.default}80` },
};
